<ng-container *ngIf="structure[index] && structure[index]['child']">
  <app-generic [structure]="structure[index]"></app-generic>
</ng-container>
